export default __webpack_public_path__ + "static/media/homestay-4085dffbeb636b820069ddc1b2674445.png";